import React, { Component } from 'react';
import { Container, Tabs, Tab, Button, Modal } from 'react-bootstrap';
import DataTable from "react-data-table-component";
import { FaFile, FaPlus } from 'react-icons/fa6';
import { GetText, ReplaceText, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../../config/helper';
import Loading from '../../inc/Loading';
import TagHeaders from '../../inc/Headers';
import '../../config/global';
import ImgLogoGemini from '../../img/logo_gemini_academy.png';
import ImgSharePrompt from '../../img/pic_share_prompt.png';
import PromptForm from '../../inc/prompt/Form';
import PromptDetail from '../../inc/prompt/Detail';

const authKey = global.config.kindcode.training[23]+global.config.authBearerKey;


function getPromptData () {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","category":"'+global.config.bannerType[2].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/promptlist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}

async function getAllDatas(actvPage) {
    
    const [thing1] = await Promise.all([getPromptData()]);
    var arrReturnValue = {};
    arrReturnValue.promptdata = thing1
            .sort((c,d) => d.content.createDate._seconds - c.content.createDate._seconds)
            .map((promptItem, j) => {
                var promptListSend = promptItem.content;
                promptListSend.id = promptItem.docid;
                promptListSend.likeData = promptItem.subcontentlist !== undefined? promptItem.subcontentlist : [];
                promptListSend.activePage = actvPage;
                return promptListSend
            });

    return arrReturnValue;
}

export default class PromptBrowseMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      memberStatus: localStorage.getItem('status'),
      currentUrl: '',
      activePage: '',
      defRowPage: 1,
      promptbankList: [],
      promptbankListAll: [],
      isLoad: false,
      modal_show_prompt: false,
      view_myprompt: false
    }
  }
  handlePopOpen(name) {
    this.setState({ 
      [name]: true,
    });
  }
  handlePopClose(name) {
    this.setState({ 
      [name]: false,
    });
  }
  handleListPrompt(stat) {
    var stat_prompt, result;
    if(stat === true) {
      result = this.state.promptbankListAll.filter((listA) =>  {
        return listA.promptStatus === global.config.promptStatus[1];
      });
      stat_prompt = false;
    } else {
      result = this.state.promptbankListAll.filter((listA) =>  {
        return listA.createById === this.state.memberId;
      });
      stat_prompt = true;
    }
    
    this.setState({
      promptbankList: result,
      view_myprompt: stat_prompt
    }) 
  }
  listPromptContent() {   
    var column = [];
    column.push({ 
      name: "Description", 
      cell: (row) => <PromptDetail value={{"currpage": this.state.activePage, "data": row, "type": "browse" }} /> 
    });

    return column;
    
  }
  componentDidMount() {    
    var currentURL = window.location.pathname;
    var arrPath = currentURL.split('/');
    
    getAllDatas(arrPath[1]).then((response) => {
      var public_data = response.promptdata.filter((listA) =>  {
        return listA.promptStatus === global.config.promptStatus[1];
      });
      this.setState({
        currentUrl: currentURL,
        activePage: arrPath[1],
        promptbankList: public_data,
        promptbankListAll: response.promptdata,
        isLoad: true
      }) 
    });
  }

  render() {

    return (
      <div className="home-gemini">
        <TagHeaders value={
                        {	
                          docid: '', 
                          title: 'Novaio Academy - Gemini Academy', 
                          description: '',
                          links: global.config.urlHost+this.state.currentUrl
                        }
                      }/>
        <section>
          <Container className='mb-4'>
            <div className='text-center'><img src={ImgLogoGemini} className='logo'/></div>
          </Container>
        </section>
        
        {
          this.state.isLoad === true ? 
              <section>
                <Container>
                  <div className="br-8">
                    {
                      GetText() ? (
                        <div>
                          <h4 className="text-start mb-1">Koleksi Prompting</h4>
                          <p className="text-start mb-4">Kumpulan prompting yang di buat dari sebuah ide dan mengubah imajinasi menjadi kenyataan.</p>
                        </div>
                      ) : (
                        <div>
                          <h4 className="text-start mb-1">Prompting Collection</h4>
                          <p className="text-start mb-4">A collection of prompts, crafted to spark ideas and turn imagination into reality.</p>
                        </div>                      
                      )
                    }
                    <div className="row mt-3">
                      <div className="col-md-9">
                        <div className="bg-light mb-3" style={{height:"2px"}}></div>
                        {
                          (this.state.promptbankList.length > 0)? (
                            <DataTable 
                              columns={this.listPromptContent()}
                              data={this.state.promptbankList}
                              noHeader={true} // Set to true to hide the title header
                              pagination
                              paginationPerPage={this.state.defRowPage}
                              paginationRowsPerPageOptions={[1, 10, 25, 50, 75, 100]}
                              customStyles={{
                                headRow: {
                                  style: {
                                    display: "none"
                                  },
                                  denseStyle: {
                                    minHeight: "32px",
                                  },
                                }
                              }}
                            />
                          
                          ) : (
                            <div className="d-flex justify-content-center align-items-center">
                              {/* The content to be centered */}
                              <div className="text-center p-3">
                                <img src={ImgSharePrompt} width="150"/><br/>
                                <Button className="mt-2" variant="primary" size="md" type="button" value="Share Prompt" id="shareprompt" onClick={this.handlePopOpen.bind(this,"modal_show_prompt")}>{GetText() ? "Bagikan Prompt Anda" : "Share your prompt"}</Button>
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <div className="col-md-3 bg-light">
                        <Button variant="link" size="sm" type="button" className="btn-light text-decoration-none mt-4" onClick={this.handlePopOpen.bind(this,"modal_show_prompt")}>
                          <FaPlus className="style-action-icons"  style={{size: "20px"}}  />
                          <span >{GetText() ? "Bagikan Prompt Anda" : "Share Your Prompt"} </span>
                        </Button>
                        <Button variant="link" size="sm" type="button" className="btn-light text-decoration-none mt-4" onClick={this.handleListPrompt.bind(this, this.state.view_myprompt)}>
                          <FaFile className="style-action-icons"  style={{size: "20px"}}  />
                          { 
                            this.state.view_myprompt === true? GetText() ? "Lihat Semua Prompt" : "All Prompt"
                            : GetText() ? "Lihat Prompt Anda" : "My Prompt"
                          } 
                        </Button>
                      </div>
                    </div>
                    
                   
                  </div>
                </Container>
              </section>
            : <Loading value={{id:'library-area', divstyle:{}, componentstyle: {}}}/>
        }

          <Modal animation={false} show={this.state.modal_show_prompt} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_prompt")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Bagikan prompt Anda" : "Share your prompt"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <PromptForm value={{"currpage": this.state.activePage}} />
            </Modal.Body>
          </Modal>
      </div>
    );
  }
}